<!-- Capture projected content for reuse in mobile menu -->
<ng-template #afterSearchBarTemplate><ng-content select="[afterSearchBar]"></ng-content></ng-template>
<ng-template #beforeExportTemplate><ng-content select="[beforeExport]"></ng-content></ng-template>

@if (loadingProgress()) {
	<prism-progress-indicator
		id="sh-loading-progress-bar"
		data-testid="loading-progress-bar"
		[ngClass]="{ 'hide-progress-bar': loadingProgress()?.state === 'Completed' }"
		type="linear"
		[mode]="loadingProgress()?.state === 'Determinate' ? 'determinate' : 'indeterminate'"
		[value]="loadingProgress()?.percentComplete"
	></prism-progress-indicator>
}

<!-- Table header with search, export, and flexible content slots -->
<div #tableHeader class="table-header" *transloco="let t">
	<!-- Slot 1: Content before search bar (always visible, wraps to full width when needed) -->
	<div class="slot1-wrapper">
		<ng-content select="[beforeSearchBar]"></ng-content>
	</div>

	<!-- All content after beforeSearchBar (search bar, slot 2, slot 3, export, and slot 4) in a non-wrapping container -->
	<div #mainControls class="main-controls-wrapper">
		<!-- Search bar -->
		@if (showSearchBar()) {
			<prism-search-bar
				id="sh-search-input-field"
				data-testid="sh-search-input-field"
				placeholder="{{ t('common.search-bar.placeholder') }}"
				(valueChange)="onSearch($event.detail)"
				(valueInput)="onSearch($event.detail)"
			/>
		}

		@if (collapseSlots2And3IntoMenu()) {
			<prism-overlay-container modal="false" placement="bottom-start" [ngClass]="'ag-theme-in-card'">
				<prism-icon-button
					id="sh-mobile-menu-icon-button"
					slot="overlay-trigger"
					icon="more_vert"
					[class.selected]="showMobileMenu()"
					(click)="onToggleMobileMenu()"
				></prism-icon-button>
				<div class="table-toolbar-buttons-overlay-container" [style.max-width.px]="mobileMenuWidth()">
					<ng-container *ngTemplateOutlet="afterSearchBarTemplate"></ng-container>
					<ng-container *ngTemplateOutlet="beforeExportTemplate"></ng-container>
					@if (showExportButton()) {
						<ng-container *ngTemplateOutlet="exportMenu"></ng-container>
					}
				</div>
			</prism-overlay-container>
		} @else {
			<!-- Slot 2: Content after search bar -->
			<ng-container *ngTemplateOutlet="afterSearchBarTemplate"></ng-container>
			<!-- Slot 3: Content before export button -->
			<div class="slot3-wrapper">
				<ng-container *ngTemplateOutlet="beforeExportTemplate"></ng-container>
			</div>
			@if (showExportButton()) {
				<!-- Export Button -->
				<ng-container *ngTemplateOutlet="exportMenu"></ng-container>
			}
		}
	</div>
</div>

<ng-template #exportMenu>
	<!-- Hack for bug in prism-menu -->
	@if (rowsCount() !== 0) {
		<prism-menu *transloco="let t" (valueChange)="onExport($event)">
			<prism-button id="sh-export" data-testid="export-button" slot="menu-trigger">
				{{ t('ag-grid.export') }}
				<prism-icon slot="icon-end" icon="arrow_drop_down"></prism-icon>
			</prism-button>
			<prism-menu-item [value]="'csv'" data-testid="sh-export-option-csv">
				{{ t('ag-grid.csvExport') }}
			</prism-menu-item>
			<prism-menu-item [value]="'xlsx'" data-testid="sh-export-option-excel">
				{{ t('ag-grid.excelExport') }}
			</prism-menu-item>
		</prism-menu>
	} @else {
		<prism-button *transloco="let t" id="sh-export" data-testid="export-button" disabled>
			{{ t('ag-grid.export') }}
			<prism-icon slot="icon-end" icon="arrow_drop_down"></prism-icon>
		</prism-button>
	}
</ng-template>
